var loader = !window._KNB_WX_LOADER ? require('@dp/weixin-js-sdk-loader') : {use: function (cb) { return cb(window.wx); }};
var miniProgramApis = require('./miniprogram-h5-apis');
var mixin = require('../common/mixin')
var noop = function () {}
var win = typeof window !== 'undefined' ? window : {}
var Promise = win.Promise || require('pinkie')
var wx = function () {
  return window.wx || ( function (ref) {
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;

    return fail({error: -1, msg: 'wx sdk is not loaded'});
  } )
}

var qparams = require('../common/qparams');
var callbackQueue = [];
var isWXJSBridgeReady = false;

function isMiniEnv() {
  return window.__wxjs_environment === 'miniprogram'
}
/**
 * 微信官方文档
 * https://mp.weixin.qq.com/wiki
 * **/

/** constants **/
var WECHAT_FRIENDS = 'WCF'
var WECHAT_TIMELINE = 'WCT'
var QQ = 'QQ'
var QZONE = 'QZONE'
/** constants **/

function uploadImages (localIds) {
  var ids = localIds.concat()
  var photos = []
  return new Promise(function (resolve, reject) {
    function uploadSingleImage () {
      var localId = ids.shift()
      if (!localId) resolve(photos)
      wx().uploadImage({
        localId: localId,
        success: function (photo) {
          photos.push(photo)
          uploadSingleImage()
        },
        fail: reject
      })
    }
    uploadSingleImage()
  })
}

var KNB = {
  use: function (name, options) {
    if (KNB[name] && !KNB[name].NOTIMPLEMENTED) return KNB[name](options)
    if (wx()[name]) wx()[name](options)
  },
  getUA: require('../common/get-ua'),

  isApiSupported: function (ref) {
    var apiName = ref.apiName;
    var success = ref.success; if ( success === void 0 ) success = noop;

    return success(!!(KNB[apiName] && !KNB[apiName].NOTIMPLEMENTED))
  },
  previewImage: function (config) { return wx().previewImage(config); },
  // 建议只用count
  chooseImage: function (ref) {
    var count = ref.count;
    var success = ref.success; if ( success === void 0 ) success = noop;
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;

    wx().chooseImage({
      count: count,
      success: function (res) {
        success({
          photoInfos: res.localIds.map(function (id) { return ({localId: id}); })
        })
      },
    fail: fail})
  },
  uploadImage: function (config) {
    var localIds = config.localIds; if ( localIds === void 0 ) localIds = [];
    var success = config.success; if ( success === void 0 ) success = noop;
    var fail = config.fail; if ( fail === void 0 ) fail = noop;

    uploadImages(localIds)
      .then(function (photos) {
        success({
          photoInfos: photos.map(function (photo) { return mixin(photo, {picUrl: photo.serverId, picKey: photo.serverId}); }
          )
        })
      })
      .catch(fail)
  },
  downloadImage: function (config) { return wx().downloadImage(config); },
  scanQRCode: function (config) {
    var success = config.success; if ( success === void 0 ) success = noop;
    var fail = config.fail; if ( fail === void 0 ) fail = noop;
    delete config.success;
    delete config.fail;
    wx().scanQRCode(mixin(config, {
      success: function (res) {
        success({ scanResult: res.resultStr });
      },
      fail: function (res) { return fail(res); }
    }))
  },

  getNetworkType: function (config) { return wx().getNetworkType(config); },
  closeWindow: function (config) { return wx().closeWindow(config); },

  // constants
  share: {
    WECHAT_FRIENDS: WECHAT_FRIENDS,
    WECHAT_TIMELINE: WECHAT_TIMELINE,
    QQ: QQ,
  QZONE: QZONE},

  // share
  // mapping from
  // [knb api]
  //   title:"分享标题",
  //   desc:"分享描述",
  //   image:"http://www.dpfile.com/toevent/img/16d05c85a71b135edc39d197273746d6.png",
  //   url:"http://m.dianping.com",
  //   channel: [KNB.share.WECHAT_FRIENDS,KNB.share.WECHAT_TIMELINE],
  // to
  // [wx api]
  //   title: '', // 分享标题
  //   desc: '', //分享描述
  //   link: '', // 分享链接
  //   imgUrl: '', // 分享图标
  configShare: function (ref) {
    var title = ref.title;
    var desc = ref.desc; if ( desc === void 0 ) desc = '';
    var image = ref.image; if ( image === void 0 ) image = '';
    var url = ref.url; if ( url === void 0 ) url = '';
    var content = ref.content; if ( content === void 0 ) content = '【' + title +  '】' +desc;
    var channel = ref.channel; if ( channel === void 0 ) channel = [WECHAT_FRIENDS, WECHAT_TIMELINE, QQ, QZONE];
    var success = ref.success; if ( success === void 0 ) success = noop;
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;

    channel
      .map(function (c) {
        switch (c) {
          case KNB.share.WECHAT_FRIENDS:
            return function (x) { return wx().updateAppMessageShareData(x); }
          case KNB.share.QQ:
            return function (x) { return wx().onMenuShareQQ(x); }
          case KNB.share.QZONE:
            return function (x) { return wx().onMenuShareQZone(x); }
          case KNB.share.WECHAT_TIMELINE:
            return function (x) { return wx().updateTimelineShareData(mixin(x, {title: content})); } 
        }
      })
      .filter(Boolean)
      .forEach(function (configure) {
        configure({
          title: title,
          desc: desc,
          link: url,
          imgUrl: image,
          success: success,
        fail: fail})
      })
  },

  getLocation: function (ref) {
    var type = ref.type; if ( type === void 0 ) type = 'wgs84';
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
    var success = ref.success; if ( success === void 0 ) success = noop;

    wx().getLocation({
      type: type,
      fail: fail,
      success: function (res) {
        success({
          lat: res.latitude,
          lng: res.longitude
        })
      }
    })
  }
}

// 所有API调用，自动放入ready里。
// 如果用户没有主动调KNB.ready，这里会自动调起鉴权。
var apis = require('../api')
apis
  .concat('use')
  .forEach(function (name) {
    if (name === 'config') return
    var isImplemented = KNB[name]
    var notImplementedMethod = function (ref) {
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      return fail({error: -2, msg: ("API [" + name + "] is not implemented")});
    };
    var method = KNB[name] || notImplementedMethod; 
    if (typeof method !== 'function') return
    KNB[name] = function (a, b, c) {
      KNB.ready(function () { return method(a, b, c); });
    }
    // 如果此时环境未区分，那么在微信小程序中调用微信拥有的方法，可能会报错
    if (isMiniEnv() && miniProgramApis.indexOf(name) === -1) {
      KNB[name] = notImplementedMethod;
      isImplemented = false;
    }

    if (!isImplemented) KNB[name].NOTIMPLEMENTED = true
    KNB[name].getSourceCode = function () { return method.toString(); } // for debug reason
  })

function wxJSBready() {
  isWXJSBridgeReady = true;
  var loop = function () {
    var cb = callbackQueue.shift();
    loader.use(function (wx) {
      wx && wx.ready && wx.ready(cb);
    })
  };

  while(callbackQueue.length) loop();
  if (!isMiniEnv()) return;
  // 兼容单独引入 knb/wx,此时没有 KNB.env
  KNB.isMiniProgramWebview = true;
  KNB.getUserInfo = function (ref) {
    var success = ref.success;
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;

    var qs = qparams(location.href);
    if (!qs.token) {
      return fail({
        errorCode: -500, 
        errorMessage: 'get userinfo failed!'
      });
    }

    success({
      type: 'wx-miniprogram',
      uuid: qs.uuid,
      token: qs.token,
      userId: qs.userId || qs.userid,
    });
  };
  //KNB > 1.5.9
  KNB.openWebview = function (ref) {
    var url = ref.url;
    var qs = ref.qs; if ( qs === void 0 ) qs = {};
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;

    if (/^knbwxmini:\/\//i.test(url)){
      var params = qparams(url);
      var navigatePath = params.path;
      var method = qs.method ? qs.method : 'navigateTo';
      if(!navigatePath) {
        return fail({
          errorCode: -400,
          errorMessage: 'get miniProgram url failed'
        });
      }
      if (/^knbwxmini:\/\/mtweapp/.test(url)) {
          var paramArray = Object.keys(params).map(function (key) {
            if (key !== 'path') {
              return (key + "=" + (params[key]));
            }
          });
          navigatePath += paramArray.join('&');
      }
      if(wx().miniProgram && wx().miniProgram[method]){
        wx().miniProgram[method]({url: navigatePath});
      } else {
        return fail({
          errorCode: -400,
          errorMessage: 'get wrong method'
        })
      }
    } else {
      location.href = url;
    }
  }
  //KNB > 1.6.0
  KNB.share = function (options) {
    var path = options.url;
    var title = options.title;
    var imageUrl = options.imageUrl;
    if (wx().miniProgram){
      wx().miniProgram.postMessage({
        data: { 
          type: 'share',  
          data: { 
            path: path,     // 分享链接 
            title: title,    // 分享标题
            imageUrl: imageUrl  // 分享图片
          } 
        }
      });
    }
  }
  if(KNB._add) {
    KNB._add('isMiniProgramWebview',true);
    KNB._add('getUserInfo',KNB.getUserInfo);
    KNB._add('share',KNB.share);
    KNB._add('openWebview',KNB.openWebview);
  }
}

if (!win.WeixinJSBridge || !win.WeixinJSBridge.invoke) {
  document.addEventListener('WeixinJSBridgeReady', wxJSBready, false)
} else {
  wxJSBready()
}

if (typeof window !== 'undefined') {
  var version = require('../common/version');
  var logEvent = require('../common/log');
  // 统计wx调用次数
  logEvent("wx", version);
}

KNB.ready = function (cb) {
  if ( cb === void 0 ) cb = noop;

  if (isWXJSBridgeReady) {
    loader.use(function (wx) {
      wx && wx.ready && wx.ready(cb);
    })
  } else {
    callbackQueue.push(cb);
  }
}; // 增加ready函数

module.exports = KNB



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/wx/index.js
// module id = 560
// module chunks = 0